export default "__VITE_PUBLIC_ASSET__100bb417__"